import { Helmet } from "react-helmet";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogType?: string;
  keywords?: string;
  noindex?: boolean;
}

const SEOHead = ({ 
  title, 
  description, 
  canonical = "https://espacespaysagesproprete.fr",
  ogType = "website",
  keywords = "nettoyage professionnel, Nantes, entretien, vitrerie, façades, bureaux, espaces verts",
  noindex = false
}: SEOHeadProps) => {
  const fullTitle = `${title} | EPP - Espaces Paysages & Propreté`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="EPP Espaces Paysages & Propreté" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;
